import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { addAdmin } from "../services/api"; 



function AddAdmin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user"); 
  const [userRole, setUserRole] = useState(""); 
  
  // Get logged-in user's assigned project from sessionStorage
  const loggedInUserProject = sessionStorage.getItem("project");

  // Default project value rules based on who is logged in
  const getInitialProject = () => {
    const storedRole = sessionStorage.getItem("userRole");
    if (storedRole !== "super_admin" && loggedInUserProject) {
      return loggedInUserProject;
    }
    return "jagranquiz";
  };

  const [project, setProject] = useState(getInitialProject);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  // Get logged-in user role from sessionStorage
  useEffect(() => {
    const storedRole = sessionStorage.getItem("userRole");
    setUserRole(storedRole);
    
    // Safety sync step to guarantee project aligns if roles load late
    if (storedRole !== "super_admin" && loggedInUserProject) {
      setProject(loggedInUserProject);
    }
  }, [loggedInUserProject]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }

    try {
      const response = await addAdmin({ email, password, role , project });

      if (response.success) {
        setSuccess("User created successfully!");
        setTimeout(() => {
            if (userRole === "super_admin") {
              navigate("/admin-list");
            } else if (userRole === "admin") {
              navigate("/user-list");
            }
          }, 2000);
        setEmail("");
        setPassword("");
        setRole("user");
        setProject(getInitialProject());
      } else {
        setError(response.message || "Failed to create user.");
      }
    } catch (err) {
      setError(err.message || "An error occurred.");
    }
  };

  return (
    <div style={styles.container}>
      {userRole === "super_admin" && <h2 style={styles.title}>Add New Admin or User</h2>}
      {userRole === "admin" && <h2 style={styles.title}>Add New User</h2>}
      {error && <p style={styles.error}>{error}</p>}
      {success && <p style={styles.success}>{success}</p>}

      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={styles.input}
        />
        <input
          type="password"
          placeholder="Password (min 6 chars)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={styles.input}
        />

        {/* Role selection based on logged-in user role */}
        <select value={role} onChange={(e) => setRole(e.target.value)} style={styles.select}>
          <option value="user">User</option>
          {userRole === "super_admin" && <option value="admin">Admin</option>}
        </select>

         {/* Project selection: Limited explicitly based on assignment */}
        <select 
          value={project} 
          onChange={(e) => setProject(e.target.value)} 
          style={styles.select}
          disabled={userRole !== "super_admin"} // Freezes option value if role isn't super_admin
        >
          {userRole === "super_admin" ? (
            <>
              <option value="jagranquiz">Jagran</option>
              <option value="joshquiz">Josh</option>
            </>
          ) : (
            // Regular admins only see their assigned brand context
            <option value={loggedInUserProject}>
              {loggedInUserProject === "joshquiz" ? "Josh" : "Jagran"}
            </option>
          )}
        </select>

        <button type="submit" style={styles.button}>Add</button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
    maxWidth: "400px",
    margin: "50px auto",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  title: {
    fontSize: "24px",
    marginBottom: "10px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    padding: "10px",
    marginBottom: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
  },
  select: {
    padding: "10px",
    marginBottom: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "16px",
    backgroundColor: "#fff",
  },
  button: {
    padding: "10px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  error: {
    color: "red",
  },
  success: {
    color: "green",
  },
};

export default AddAdmin;

// function AddAdmin() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [role, setRole] = useState("user"); // Default role
//   const [userRole, setUserRole] = useState(""); // Role of the logged-in user
//    const [project, setProject] = useState("jagranquiz"); // Default role
//   //const [userProjet, setUserProjet] = useState("");
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const navigate = useNavigate();

//   // Get logged-in user role from sessionStorage
//   useEffect(() => {
//     const storedRole = sessionStorage.getItem("userRole");
//     setUserRole(storedRole);
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccess("");

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(email)) {
//       setError("Please enter a valid email address.");
//       return;
//     }
//     if (password.length < 6) {
//       setError("Password must be at least 6 characters long.");
//       return;
//     }

//     try {
//       const response = await addAdmin({ email, password, role , project});

//       if (response.success) {
//         setSuccess("Admin user created successfully!");
//         setTimeout(() => {
//             if (userRole === "super_admin") {
//               navigate("/admin-list");
//             } else if (userRole === "admin") {
//               navigate("/user-list");
//             }
//           }, 2000);
//         setEmail("");
//         setPassword("");
//         setRole("user");
//         setProject("jagranquiz");
//       } else {
//         setError(response.message || "Failed to create admin.");
//       }
//     } catch (err) {
//       setError(err.message || "An error occurred.");
//     }
//   };

//   return (
//     <div style={styles.container}>
//       {userRole === "super_admin" && <h2 style={styles.title}>Add New Admin or User</h2>}
//       {userRole === "admin" && <h2 style={styles.title}>Add New User</h2>}
//       {error && <p style={styles.error}>{error}</p>}
//       {success && <p style={styles.success}>{success}</p>}

//       <form onSubmit={handleSubmit} style={styles.form}>
//         <input
//           type="email"
//           placeholder="Email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//           style={styles.input}
//         />
//         <input
//           type="password"
//           placeholder="Password (min 6 chars)"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//           style={styles.input}
//         />

//         {/* Role selection based on logged-in user role */}
//         <select value={role} onChange={(e) => setRole(e.target.value)} style={styles.select}>
//           <option value="user">User</option>
//           {userRole === "super_admin" && <option value="admin">Admin</option>}
//         </select>


//          {/* project based on logged-in user role */}
//         <select value={project} onChange={(e) => setProject(e.target.value)} style={styles.select}>
//           <option value="jagranquiz">jagran</option>
//           {userRole === "super_admin" && <option value="joshquiz">josh</option>}
//         </select>

//         <button type="submit" style={styles.button}>Add</button>
//       </form>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     padding: "20px",
//     maxWidth: "400px",
//     margin: "50px auto",
//     backgroundColor: "#fff",
//     borderRadius: "8px",
//     boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//     textAlign: "center",
//   },
//   title: {
//     fontSize: "24px",
//     marginBottom: "10px",
//   },
//   form: {
//     display: "flex",
//     flexDirection: "column",
//   },
//   input: {
//     padding: "10px",
//     marginBottom: "10px",
//     border: "1px solid #ccc",
//     borderRadius: "5px",
//   },
//   select: {
//     padding: "10px",
//     marginBottom: "10px",
//     border: "1px solid #ccc",
//     borderRadius: "5px",
//     fontSize: "16px",
//   },
//   button: {
//     padding: "10px",
//     backgroundColor: "#007bff",
//     color: "#fff",
//     border: "none",
//     borderRadius: "5px",
//     cursor: "pointer",
//   },
//   error: {
//     color: "red",
//   },
//   success: {
//     color: "green",
//   },
// };

// export default AddAdmin;
